<template>
  <a class="company-box" :href="`/company/${data.token}.html`">
    <div class="company-main-box">
      <div class="company-info">
        <img :src="data.logo" alt="" width="40" height="40">
        <div>
          <p class="company-name">{{data.company_nick_name || data.company_full_name}}</p>
          <p class="company-ps">{{data.industry.cn ? data.industry.cn + ' | ' : ''}} {{data.company_type ? data.company_type + ' | ' : ''}}{{getCompanyScale(data.size_min,data.size_max)}}</p>
        </div>
      </div>
      <div class="recommend-text" v-if="data.suggestions">
        {{data.suggestions}}
      </div>
      <div class="interpolate-box">
        <p>有 <span>{{data.internal_recommends_count || 3}}</span> 名用户可以帮你内推</p>
        <i class="iconfont iconchevron-right"></i>
      </div>
    </div>
  </a>
</template>

<script>
import { getCompanyScale } from '@/assets/js/utils'
  export default {
    name: "companyCard",
    props:{
      data:{
        type: Object,
        default:()=>{
          return {}
        }
      }
    },
    mounted:{
      getCompanyScale
    },
  }
</script>

<style scoped lang="scss">
.company-box{
  padding: 21px 24px 10px;
  background-color: #fff;
  box-sizing: border-box;
  display: block;
  .company-main-box{
    box-sizing: border-box;
    background: #FFFFFF;
    box-shadow: 0px 1px 10px 0px rgba(3, 47, 129, 0.08);
    border-radius: 8px 2px 8px 8px;
    padding: 16px 16px 12px 16px;
    .company-info{
      padding-bottom: 10px;
      display: flex;
      &>img{
        margin-right: 10px;
        border: 1px solid #f9f9f9;
      }
      .company-name{
        font-size: 16px;
        font-weight: 500;
        color: #404040;
        line-height: 16px;
        margin-top: 2px;
        margin-bottom: 6px;
      }
      .company-ps{
        font-size: 14px;
        font-weight: 400;
        color: #606060;
        line-height: 14px;
        width: 237px;
        box-sizing: border-box;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
      }

    }
    .recommend-text{
      width: 295px;
      background: #F9F9F9;
      border-radius: 4px;
      padding: 8px 11px;
      font-size: 12px;
      font-weight: 400;
      color: #9C9C9C;
      line-height: 17px;
      box-sizing: border-box;
      overflow: hidden;
      text-overflow:ellipsis;
      white-space: nowrap;
      margin-bottom: 12px;
    }
    .interpolate-box{
      padding-top: 12px;
      text-align: center;
      width: 327px;
      margin-left: -16px;
      font-size: 14px;
      font-weight: 400;
      color: #606060;
      line-height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-top: 1px solid #f9f9f9;
      & span{
        color: #ff6644;
      }
      p{
        margin-right: 6px;
      }
      .iconfont{
        color: #BCBCBC;
      }
    }
  }
}
</style>
